// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1Wqsv","col":"styles_col__H2r6m"};